import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=bd2844cc&"
import script from "./BlogList.vue?vue&type=script&lang=js&"
export * from "./BlogList.vue?vue&type=script&lang=js&"
import style0 from "./BlogList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports